export default __webpack_public_path__ + "static/media/1.24b5acfe.png";